import React, { useEffect, useState } from "react";

export function MediaPlayer({ media, onClose }) {
 const [visible, setVisible] = useState(false);

 useEffect(() => {
  // Trigger zoom-in animation after mount
  setVisible(true);
 }, []);

 const handleClose = () => {
  // Trigger zoom-out animation
  setVisible(false);

  // Wait for animation to finish before calling parent's onClose
  setTimeout(() => {
   onClose();
  }, 300); // match duration of CSS transition
 };

 if (!media) return null;

 const isVideo = (url) => {
  const ext = url.split("?")[0].split(".").pop().toLowerCase();
  return ["mp4", "webm", "ogg"].includes(ext);
 };

 return (
  <div
   onClick={handleClose}
   className={`fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 cursor-pointer
        transition-opacity duration-300
        ${visible ? "opacity-100" : "opacity-0"}`}
   style={{ backdropFilter: "blur(8px)" }}
  >
   <div
    onClick={(e) => e.stopPropagation()}
    className={`relative max-w-4xl max-h-[90vh] w-full mx-4 rounded-lg overflow-hidden
          transition-transform duration-300
          ${visible ? "scale-100" : "scale-90"}`}
   >
    {isVideo(media.url) ? (
     <video
      src={media.url}
      controls
      autoPlay
      className="w-full h-auto max-h-[90vh] rounded-lg"
     />
    ) : (
     <img
      src={media.url}
      alt={media.description || "Media"}
      className="w-full h-auto max-h-[90vh] rounded-lg"
     />
    )}
    <button
     onClick={handleClose}
     className="absolute top-2 right-2 text-white bg-black bg-opacity-50 rounded-full w-8 h-8 flex items-center justify-center hover:bg-opacity-80 transition"
     aria-label="Close media player"
    >
     ✕
    </button>
   </div>
  </div>
 );
}
